import QueryString from 'qs';

import { jsonApi } from '../client';
import { PaginationQuery, PaginationResource } from '../types/pagination';
import { Activity } from './types';

export interface ActivityRelationApi {
  name: string;
  parentName: string;
  parentId: number | string;
  index: (query?: PaginationQuery) => Promise<PaginationResource<Activity>>;
}

export const activityRelationApi =
  (relationName: string) =>
  (relationId: string | number): ActivityRelationApi => {
    const activityRelation = jsonApi(`${relationName}/${relationId}/activity`);

    const index = (query?: PaginationQuery): Promise<PaginationResource<Activity>> => {
      return activityRelation.get(undefined, {
        searchParams: QueryString.stringify(query),
      });
    };

    return {
      name: `${relationName}-${relationId}-activity`,
      parentName: relationName,
      parentId: relationId,
      index,
    };
  };
